import { EnvelopeIcon } from '@heroicons/react/24/outline';

export function CommunicationDetailsEmpty() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="max-w-md p-6 text-center">
        <div className="mx-auto mb-4 flex size-16 items-center justify-center rounded-full bg-gray-200">
          <EnvelopeIcon className="size-8 text-gray-600" />
        </div>
        <h3 className="text-lg font-medium text-gray-800">
          No communication selected
        </h3>
        <p className="mt-2 text-sm text-gray-600">
          Select a communication from the list to view its details here.
        </p>
      </div>
    </div>
  );
}
